export const MARKETS_FETCH = 'markets/FETCH';
export const MARKETS_DATA = 'markets/DATA';
export const MARKETS_ERROR = 'markets/ERROR';
export const MARKETS_SET_CURRENT_MARKET = 'markets/SET_CURRENT_MARKET';
export const MARKETS_SET_CURRENT_MARKET_IFUNSET = 'markets/SET_CURRENT_MARKET_IFUNSET';
export const MARKETS_TICKERS_FETCH = 'markets/TICKERS_FETCH';
export const MARKETS_TICKERS_PUSH = 'markets/TICKERS_PUSH';
export const MARKETS_TICKERS_ERROR = 'markets/TICKERS_ERROR';
export const MARKETS_TICKERS_DATA = 'markets/TICKERS_DATA';
